module.exports = __webpack_public_path__ + "static/media/geoplasmamap.10d26c9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/geoplasmamap.png
// module id = 1450
// module chunks = 0